import type {ReactElement} from 'react';
import {FontHeading} from '@Components/font-selector-panel/components/font-heading';
import type {FontData} from '@Libraries/font-library';
import { getScriptDisplayName} from '@Libraries/font-library';
import {FontsList} from '@Components/font-selector-panel/components/fonts-list';
import type {OnSelectFontFamilyCallback} from '@Components/font-selector-panel/font-selector.types';
import {useAppSelector} from '@/hooks';

interface RecommendedFontsSectionProps {
  className?: string;
  script?: string;
  selectedFontFamily?: string;
  onSelectFontFamily?: OnSelectFontFamilyCallback;
}

export function RecommendedFontsSection({
  className = '',
  script = '',
  onSelectFontFamily = (): void => {},
  selectedFontFamily = '',
}: RecommendedFontsSectionProps): ReactElement<any> | null {
  const pmwFonts = useAppSelector((state) => {
    return state.fontSelector.pmwFonts as Array<FontData> | null;
  });

  if (!pmwFonts || !script) {
    return null;
  }

  const doScriptsMatchTheRecommendedScript = (scripts: Array<string>): boolean => {
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].toLowerCase() === script.toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  const getRecommendedFontsList = (): ReactElement<any> | null => {
    if (!pmwFonts || !script) {
      return null;
    }

    const recommendedFontsByScript = pmwFonts.filter((font): boolean => {
      return doScriptsMatchTheRecommendedScript(font.script);
    });
    return <FontsList selectedFontFamily={selectedFontFamily} onSelectFontFamily={onSelectFontFamily} fontNames={recommendedFontsByScript} />;
  };

  return (
    <div className={className}>
      <FontHeading
        heading={window.i18next.t('pmwjs_recommended_for', {
          scriptName: getScriptDisplayName(script),
        })}
      />
      {getRecommendedFontsList()}
    </div>
  );
}
